/** @format */

export function getAttributeFromObject(
  attribute,
  object,
  defaultValue = false,
) {
  const path = attribute.split('.');
  let value = object;
  path.forEach(piece => {
    value = value[piece] ? value[piece] : defaultValue;
  });

  return value;
}
